import { CATEGORY_TYPE } from './constants';

export const categoryTypeRadioOptions = [
  {
    label: 'Sản phẩm',
    value: CATEGORY_TYPE.PRODUCT,
  },
  {
    label: 'Sản phẩm dịch vụ',
    value: CATEGORY_TYPE.EQUIPMENT,
  },
];

export const categoryTypeOptions = [
  {
    label: 'Tất cả',
    value: CATEGORY_TYPE.ALL,
  },
  {
    label: 'Sản phẩm',
    value: CATEGORY_TYPE.PRODUCT,
  },
  {
    label: 'Thiết bị',
    value: CATEGORY_TYPE.EQUIPMENT,
  },
  {
    label: 'Sản phẩm tiêu hao',
    value: CATEGORY_TYPE.CONSUMABLE_SUPPLIES,
  },
];
